import { render, staticRenderFns } from "./TextDropdown.vue?vue&type=template&id=17f0c10e&"
import script from "./TextDropdown.vue?vue&type=script&lang=js&"
export * from "./TextDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports